/**
 * Lightweight alert message utility
 * Extracted from common.js to avoid importing entire common module
 */

'use strict';

/**
 * Display alert message to user
 * @param {String} $text - Text to display
 * @param {String} $class - Class to add to the alert
 * @param {Boolean} hasCartLink - Whether to show cart link
 * @param {Boolean} hasWishlistLink - Whether to show wishlist link
 */
const alertMessage = ($text, $class, hasCartLink = false, hasWishlistLink = false) => {
    const successTimeout = 4000;
    const linkToCartTimeout = 6000;
    const dangerTimeout = 6000;
    let timeout = successTimeout;

    const $alert = $('.js-alert');
    const $alertMessage = $('.js-alert-message');

    let lastFocusedElement = null;

    if ($text && $text !== '') {
        // Save last focused element (keyboard users only)
        if (!$('body').hasClass('using-mouse') && !$(document.activeElement).closest('.js-overlay, .modal, .cc-overlay').length) {
            lastFocusedElement = document.activeElement;
        }

        // Immediately update the message BEFORE showing the alert
        let messageHTML = $text;
        if (hasCartLink && $class !== 'cc-alert--danger') {
            timeout = linkToCartTimeout;
            const cartUrl = $alertMessage.data('cart-link') || '';
            const gotoCartLabel = $alertMessage.data('cart-text') || '';
            messageHTML += ` <a class="cc-alert__link-cart" href="${cartUrl}" aria-hidden="true" tabindex="-1">${gotoCartLabel}</a>`;
        } else if (hasWishlistLink && $class !== 'cc-alert--danger') {
            timeout = linkToCartTimeout;
            const wishlistUrl = $alertMessage.data('wishlist-link') || '';
            const gotoWishlistLabel = $alertMessage.data('wishlist-text') || '';
            messageHTML += ` <a class="cc-alert__link-cart" href="${wishlistUrl}" aria-hidden="true" tabindex="-1">${gotoWishlistLabel}</a>`;
        }

        // Show the alert and make it accessible
        $alert
            .removeClass('cc-active') // reset state
            .removeClass('cc-alert--danger cc-alert--success cc-alert--info') // remove old styles
            .attr('aria-hidden', 'false')
            .attr('tabindex', '0')
            .addClass($class)
            .addClass('cc-active');

        $alertMessage.empty().html(messageHTML);

        // Move focus for screen reader if using keyboard
        /* if (lastFocusedElement && !$('body').hasClass('using-mouse')) {
            $alert.focus();
        } */

        // Determine timeout based on type
        if ($class === 'cc-alert--danger') {
            timeout = dangerTimeout;
            $alert.find('.js-alert-error-icon').removeClass('d-none');
            $alert.find('.js-alert-check-icon').addClass('d-none');
        } else {
            $alert.find('.js-alert-error-icon').addClass('d-none');
            $alert.find('.js-alert-check-icon').removeClass('d-none');
        }

        const hideAlert = () => {
            $alert
                .removeClass($class)
                .removeClass('cc-active')
                .attr('aria-hidden', 'true')
                .attr('tabindex', '-1');

            /* if (lastFocusedElement && typeof lastFocusedElement.focus === 'function' && document.body.contains(lastFocusedElement)) {
                lastFocusedElement.focus();
            } */
        };

        setTimeout(hideAlert, timeout);
    }
};

module.exports = alertMessage;